var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["for", "oftype"]
var hoisted3 = ["id", "oftype", "class", "form-control input-sm"]
var __target

module.exports = function description (model, root) {
  elementOpen("div", "6c0a1833-c4c2-4923-b294-2c42fe38b979", hoisted1)
    elementOpen("label", "4872cb52-09a2-4851-8e61-3d177cbdfbaf", hoisted2)
      text("Of")
    elementClose("label")
    elementOpen("select", "b6aca142-a1a8-417a-b141-896f9a9b3b98", hoisted3, "value", model.oftype, "onchange", function ($event) {
      var $element = this;
    model.oftype = this.value})
      __target = root.staticTypes
      if (__target) {
        ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
          var type = $value
          var $key = "90f8ca52-7693-4562-9565-58158a75480d_" + $item
          elementOpen("option", $key, null, "value", type, "selected", model.oftype === type ? 'selected' : null)
            text("" + (type) + "")
          elementClose("option")
        }, this)
      }
    elementClose("select")
  elementClose("div")
  var defsView = require('../defs.html')
      defsView(model.oftype, model.def, root)
}
